import React, { Component, PropTypes } from 'react';
import { AutoSizer, Table, Column, SortDirection } from 'react-virtualized';
import Popover from 'react-simple-popover';
import moment from 'moment';
import * as util from 'lib/utility';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as manageActionCreators from 'state/modules/manage';
import * as filterActionCreators from 'state/modules/filter';
import shallowCompare from 'react-addons-shallow-compare';
import { TabbedView, TabbedViewAssign, Carousel, InspCarousel } from 'containers';
import { CustomTextFieldWithCloseIcon } from 'components';
import Checkbox from 'react-toolbox/lib/checkbox';
import Modal from 'react-modal';
import 'react-virtualized/styles.css';
import styles from './VirtualTable.css';
import SortIndicator from './SortIndicator.js';

const debug = _debug('app:VirtualTable');
/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
const detectIE = () => {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return true;
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    return true;
  }

  const edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return false;
  }

  // other browser
  return false;
};

// Get IE or Edge browser version
const isIE = detectIE();
class VirtualTable extends Component {
  static defaultProps = {
    headerHeight: 65,
    headerClassName: (__MANAGE__) ? styles.manageHeaderView : styles.assignHeaderView,
    gridClassName: (__MANAGE__) ? styles.manageTableGrid : ''
  }
  static propTypes = {
    columnData: PropTypes.arrayOf(PropTypes.shape({})),
    headerHeight: PropTypes.number,
    headerClassName: React.PropTypes.string,
    rowHeight: PropTypes.func,
    updateProgressBarValue: PropTypes.func,
    rowClassName: PropTypes.func,
    rowClickHandler: PropTypes.func,
    updateSelectedRecords: PropTypes.func,
    selectedRecords: PropTypes.arrayOf(PropTypes.shape({})),
    height: PropTypes.number,
    width: PropTypes.number,
    list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    paginateList: PropTypes.func,
    activeIndex: PropTypes.number,
    gridClassName: PropTypes.string,
    popupVisible: PropTypes.string,
    applySearchName: PropTypes.func,
    applySearchStreet: PropTypes.func,
    applySearchAddress: PropTypes.func,
    applySearchWritingAgent: PropTypes.func,
    fetchData: PropTypes.func,
    tabSearchList: PropTypes.arrayOf(PropTypes.shape({})),
    priAndSecRecordMapping: PropTypes.shape({}),
    deletePersonalLeadData: PropTypes.func,
    applyFilter: PropTypes.func,
    applyFilterIndex: PropTypes.func,
    manageCampaignData: React.PropTypes.shape([]),
    fetchManageCampaignData: PropTypes.func,
    searchValueName: PropTypes.string,
    searchStreetAddress: PropTypes.string,
    searchWritingAgent: PropTypes.string,
    strings: PropTypes.shape({}),
    updateNameSearchParameter: PropTypes.func,
    updateStreetSearchParameter: PropTypes.func,
    updateWritingAgentParameter: PropTypes.func,
    filterValues: PropTypes.shape({}),
    clearFilterIndex: PropTypes.func,
    shouldCloseCarousel: PropTypes.bool,
    callCloseCarousel: PropTypes.func,
    currentLanguage: React.PropTypes.string,
    searchActivePage: React.PropTypes.func,
    updateRowData: PropTypes.func,
    rowData: PropTypes.arrayOf(PropTypes.shape({})),
    updatePhoneParameter: PropTypes.func,
    searchPhone: PropTypes.string,
    applySearchPhone: PropTypes.func,
    ownerId: PropTypes.string,
    filterExpanded: PropTypes.bool,
    fetchOpenLeadDataArray: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {
      expandedIndex: '',
      sortBy: (!__MANAGE__ && props.activeIndex === 2) ? 'expires' : 'name',
      sortDirection: SortDirection.ASC,
      startIndex: 0,
      stopIndex: 0,
      active: false,
      deleteMessage: '',
      open: false,
      confirm: false,
      checkBoxValidation: true
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.shouldCloseCarousel &&
     this.props.shouldCloseCarousel !== nextProps.shouldCloseCarousel) {
      this.closeCarousel(this.state.expandedIndex);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.expandedIndex !== this.state.expandedIndex) {
      this.virtualTable.recomputeRowHeights();
    }
  }

  componentWillUnmount() {
    const { filterValues } = this.props;
    // Following conditions have been added to clear filters applied in Inspections
    // while navigating to other tabs
    if (!__MANAGE__ && this.props.activeIndex === 2 && this.checkAnyFilterValues(filterValues)) {
      this.props.clearFilterIndex(2);
      this.props.applyFilterIndex(2);
      this.props.updateNameSearchParameter('', 2);
      this.props.updateWritingAgentParameter('', 2);
    }
  }

  setRef = (ref) => {
    this.virtualTable = ref;
  }
  getSortedPaginatedList = () => {
    if (!__MANAGE__ && this.props.activeIndex === 2) {
      const sortedList = util.orderByInspections(
        this.props.list,
        this.state.sortBy,
        this.state.sortDirection,
        SortDirection
      );
      const newerInspectionList = [];
      const otherInspectionList = [];
      sortedList.forEach((data) => {
        const fdifDate = data.cica_fdif;
        const currentDate = moment().format('l');
        const fdifDateFormat = moment(fdifDate, 'M/D/YYYY');
        const currentDateFormat = moment(currentDate, 'M/D/YYYY');
        const days = currentDateFormat.diff(fdifDateFormat, 'days');
        if (days <= 91) {
          newerInspectionList.push(data);
        } else if (days > 91) {
          otherInspectionList.push(data);
        }
      });
      const sortedListData = [...newerInspectionList, ...otherInspectionList];
      this.paginatedData = (sortedList.length > 0) ?
      this.props.paginateList(this.props.activeIndex, sortedListData) : sortedListData;
    } else if (this.state.sortBy === 'tier' && !__MANAGE__) {
      const sortedList = util.orderBy(
        this.props.list,
        this.state.sortBy,
        this.state.sortDirection,
        SortDirection
      );
      const sortedListTier = (this.state.sortDirection === 'DESC') ? sortedList.sort((a, b) => (b.tier) - (a.tier)) : sortedList.sort((a, b) => (a.tier) - (b.tier));
      const orphanedLeads = sortedListTier.filter(elt => elt.isappointmentterminated === true || elt.isappointmentterminated === 1 || elt.isappointmentterminated === '1');
      const warmLeads = sortedListTier.filter(elt => elt.leadType === 'Warm' && elt.isappointmentterminated !== true && elt.isappointmentterminated !== 1 && elt.isappointmentterminated !== '1');
      const campaignLeads = sortedListTier.filter(elt => elt.leadType === 'Campaign' && elt.isappointmentterminated !== true && elt.isappointmentterminated !== 1 && elt.isappointmentterminated !== '1');
      const otherLeads = sortedListTier.filter(elt => elt.leadType !== 'Warm' && elt.leadType !== 'Campaign' && elt.isappointmentterminated !== true && elt.isappointmentterminated !== 1 && elt.isappointmentterminated !== '1');
      const sortedListData = [...warmLeads, ...orphanedLeads, ...campaignLeads, ...otherLeads];
      // As per Requirement, sortedListData order should be like warm ,campain and otherleads.
      this.paginatedData = (sortedListData.length > 0) ?
      this.props.paginateList(this.props.activeIndex, sortedListData) : sortedListData;
    } else if (this.state.sortBy === 'tier' && __MANAGE__) {
      const sortedList = util.orderBy(
        this.props.list,
        this.state.sortBy,
        this.state.sortDirection,
        SortDirection
      );
      const sortedListTier = (this.state.sortDirection === 'DESC') ? sortedList.sort((a, b) => (b.tier) - (a.tier)) : sortedList.sort((a, b) => (a.tier) - (b.tier));
      const orphanedLeads = sortedListTier.filter(elt => ((elt.leadType !== '') && (elt.isappointmentterminated === true || elt.isappointmentterminated === 1 || elt.isappointmentterminated === '1' || elt.isappointmentterminated === 'true')));
      const warmLeads = sortedListTier.filter(elt => elt.leadType === 'Warm' && elt.isappointmentterminated !== true && elt.isappointmentterminated !== 1 && elt.isappointmentterminated !== '1' && elt.isappointmentterminated !== 'true');
      const campaignLeads = sortedListTier.filter(elt => elt.leadType === 'Campaign' && elt.isappointmentterminated !== true && elt.isappointmentterminated !== 1 && elt.isappointmentterminated !== '1' && elt.isappointmentterminated !== 'true');
      const otherLeads = sortedListTier.filter(elt => (elt.leadType !== 'Warm') && elt.leadType !== 'Campaign' && elt.isappointmentterminated !== true && elt.isappointmentterminated !== 1 && elt.isappointmentterminated !== '1' && elt.isappointmentterminated !== 'true');
      const sortedListData = [...warmLeads, ...orphanedLeads, ...campaignLeads, ...otherLeads];
      // As per Requirement, sortedListData order should be like warm ,campain and otherleads.
      this.paginatedData = (sortedListData.length > 0) ?
      this.props.paginateList(this.props.activeIndex, sortedListData) : sortedListData;
    } else if (this.state.sortBy === 'expires' && __MANAGE__) {
      const sortedList = util.orderBy(
        this.props.list,
        this.state.sortBy,
        this.state.sortDirection,
        SortDirection
      );
      const sortedListTier = (this.state.sortDirection === 'DESC') ? sortedList.sort((a, b) => (b.expires) - (a.expires)) : sortedList.sort((a, b) => (a.expires) - (b.expires));
      const orphanedLeads = sortedListTier.filter(elt => ((elt.leadType !== '') && (elt.isappointmentterminated === true || elt.isappointmentterminated === 1 || elt.isappointmentterminated === '1' || elt.isappointmentterminated === 'true')));
      const warmLeads = sortedListTier.filter(elt => elt.leadType === 'Warm' && elt.isappointmentterminated !== true && elt.isappointmentterminated !== 1 && elt.isappointmentterminated !== '1' && elt.isappointmentterminated !== 'true');
      const campaignLeads = sortedListTier.filter(elt => elt.leadType === 'Campaign' && elt.isappointmentterminated !== true && elt.isappointmentterminated !== 1 && elt.isappointmentterminated !== '1' && elt.isappointmentterminated !== 'true');
      const otherLeads = sortedListTier.filter(elt => (elt.leadType !== 'Warm') && elt.leadType !== 'Campaign' && elt.isappointmentterminated !== true && elt.isappointmentterminated !== 1 && elt.isappointmentterminated !== '1' && elt.isappointmentterminated !== 'true');
      const sortedListData = [...warmLeads, ...orphanedLeads, ...campaignLeads, ...otherLeads];
      // As per Requirement, sortedListData order should be like warm ,campain and otherleads.
      this.paginatedData = (sortedListData.length > 0) ?
      this.props.paginateList(this.props.activeIndex, sortedListData) : sortedListData;
    } else if (this.state.sortBy === 'disposition' && !__MANAGE__) {
      const sortedList = util.orderBy(
        this.props.list,
        this.state.sortBy,
        this.state.sortDirection,
        SortDirection
      );
      const sortedListTier = (this.state.sortDirection === 'DESC') ? sortedList.sort((a, b) => { return b.disposition.localeCompare(a.disposition); }) : sortedList.sort((a, b) => { return a.disposition.localeCompare(b.disposition); }); // eslint-disable-line
      const orphanedLeads = sortedListTier.filter(elt => elt.isappointmentterminated === true || elt.isappointmentterminated === 1 || elt.isappointmentterminated === '1');
      const warmLeads = sortedListTier.filter(elt => elt.leadType === 'Warm' && elt.isappointmentterminated !== true && elt.isappointmentterminated !== 1 && elt.isappointmentterminated !== '1');
      const campaignLeads = sortedListTier.filter(elt => elt.leadType === 'Campaign' && elt.isappointmentterminated !== true && elt.isappointmentterminated !== 1 && elt.isappointmentterminated !== '1');
      const otherLeads = sortedListTier.filter(elt => elt.leadType !== 'Warm' && elt.leadType !== 'Campaign' && elt.isappointmentterminated !== true && elt.isappointmentterminated !== 1 && elt.isappointmentterminated !== '1');
      const sortedListData = [...warmLeads, ...orphanedLeads, ...campaignLeads, ...otherLeads];
      // As per Requirement, sortedListData order should be like warm ,campain and otherleads.
      this.paginatedData = (sortedListData.length > 0) ?
      this.props.paginateList(this.props.activeIndex, sortedListData) : sortedListData;
    } else {
      const sortedList = util.orderBy(
        this.props.list,
        this.state.sortBy,
        this.state.sortDirection,
        SortDirection
      );
      const warmLeads = sortedList.filter(elt => elt.leadType === 'Warm' && elt.isappointmentterminated !== true && elt.isappointmentterminated !== 'true' && elt.isappointmentterminated !== 1 && elt.isappointmentterminated !== '1');
      const orphanedLeads = sortedList.filter(elt => elt.leadType !== '' && (elt.isappointmentterminated === true || elt.isappointmentterminated === 'true' || elt.isappointmentterminated === 1 || elt.isappointmentterminated === '1'));
      const campaignLeads = sortedList.filter(elt => elt.leadType === 'Campaign' && elt.isappointmentterminated !== true && elt.isappointmentterminated !== 'true' && elt.isappointmentterminated !== 1 && elt.isappointmentterminated !== '1');
      const otherLeads = sortedList.filter(elt => elt.leadType !== 'Warm' && elt.leadType !== 'Campaign' && elt.isappointmentterminated !== true && elt.isappointmentterminated !== 'true' && elt.isappointmentterminated !== 1 && elt.isappointmentterminated !== '1');
      const sortedListData = [...warmLeads, ...orphanedLeads, ...campaignLeads, ...otherLeads];
      // As per Requirement, sortedListData order should be like warm ,campain and otherleads.
      this.paginatedData = (sortedListData.length > 0) ?
      this.props.paginateList(this.props.activeIndex, sortedListData) : sortedListData;
    }
  }

  getRecord = (index) => {
    if (index > -1 && this.paginatedData.length > 0) {
      return this.paginatedData[index];
    }
    return null;
  }

  getNumberOfSelectedRecords = () => {
    let recordsSelected = 0;
    this.paginatedData.forEach((element) => {
      if (util.contains(this.props.selectedRecords, element, obj => obj.id === element.id)) {
        recordsSelected += 1;
      }
    });
    return recordsSelected;
  }

  checkAnyFilterValues = (filterValues) => {
    const filterCheck = Object.keys(filterValues).map((item) => {
      if (filterValues[item].length > 0) {
        return true;
      }
      return false;
    });
    return filterCheck;
  }

  deletePersonalLeadData = (rowData) => {
    this.handleToggle();
    this.props.deletePersonalLeadData(rowData.id).then(() => {
      this.refreshTable();
    }, () => this.refreshTable());
  }

  okBtnTapped = () => {
    this.deletePersonalLeadData(this.props.rowData);
  }

  action = [];

  handleToggle = () => {
    this.setState({ confirm: !this.state.confirm });
  }

  noRowsRenderer = () => {
    const { strings } = this.props;
    if (!__MANAGE__ && !this.props.list.length) {
      if (this.props.activeIndex === 2) {
        return (
          <div>
            <span>
              {strings.noInspectionsFound}
            </span>
          </div>
        );
      }
      return (
        <div>
          <span>
            {strings.noLeadsAssigned}
          </span>
        </div>
      );
    } else if (__MANAGE__ && this.props.activeIndex === 1) {
      return (
        <div>
          <span>
            {strings.openLeadsSearchString}
          </span>
        </div>
      );
    } else if (__MANAGE__ && this.props.activeIndex === 2 && !this.props.list.length) {
      return (
        <div>
          <span>
            {strings.closedViewTabCheck}
          </span>
        </div>
      );
    } else if (__MANAGE__ && this.props.activeIndex === 0 && !this.props.list.length) {
      return (
        <div>
          <span>
            {strings.priorityViewTabCheck}
          </span>
        </div>
      );
    }
    return (
      <div>
        <span>
          Your search did not match any records. Please update the filter criteria and try again.
        </span>
      </div>
    );
  }

  rowClassName = ({ index }) => {
    const rowData = this.getRecord(index);
    const id = rowData ? rowData.id : null;
    // Return the index of the first element in the array that has id equal to selected record.
    const checkId = obj => obj.id === id;
    if (index < 0) {
      return styles.flexTableHeaderView;
    }
    if (!__MANAGE__ && id && this.props.selectedRecords.findIndex(checkId) > -1) {
      return styles.selectedRow;
    }
    if (rowData.leadType === 'Warm' && (rowData.isappointmentterminated === null || rowData.isappointmentterminated === '0' || rowData.isappointmentterminated === 0 || rowData.isappointmentterminated === 'false' || rowData.isappointmentterminated === false)) {
      return styles.warmRow;
    }
    if ((rowData.leadType !== '') && (rowData.isappointmentterminated === true || rowData.isappointmentterminated === 1 || rowData.isappointmentterminated === '1' || rowData.isappointmentterminated === 'true')) {
      return styles.terminatedRow;
    }
    if (rowData.leadType === 'Campaign' && (rowData.isappointmentterminated === null || rowData.isappointmentterminated === '0' || rowData.isappointmentterminated === 0 || rowData.isappointmentterminated === 'false' || rowData.isappointmentterminated === false)) {
      return styles.campaignRow;
    }
    if (!__MANAGE__ && this.props.activeIndex === 2) {
      const fdifDate = rowData.cica_fdif;
      const currentDate = moment().format('l');
      const fdifDateFormat = moment(fdifDate, 'M/D/YYYY');
      const currentDateFormat = moment(currentDate, 'M/D/YYYY');
      const days = currentDateFormat.diff(fdifDateFormat, 'days');
      return days > 91 ? styles.oddRow : styles.campaignRow;
    }

    return index % 2 === 0 ? styles.evenRow : styles.oddRow;
  }
  clickHandler = ({ index }) => {
    // Return the index of the first element in the array that has id equal to selected record.
    const checkBoxValue = this.state.checkBoxValidation;
    if (__MANAGE__ || ((!__MANAGE__ && (this.props.activeIndex === 2)) ||
      ((!__MANAGE__ && (this.props.activeIndex === 0 || this.props.activeIndex === 1) &&
      (checkBoxValue === false || checkBoxValue === undefined))))) {
      if (this.state.expandedIndex !== index) {
        this.setState({
          expandedIndex: index
        });
        setTimeout(() => {
          if (this.refToTable) {
            this.refToTable.scrollIntoView({ block: 'start', behavior: 'smooth' });
          }
        }, 200);
      }
    }
  }
  closeCarousel = (index) => {
    if (this.state.expandedIndex === index) {
      this.setState({
        expandedIndex: ''
      });
    }
  }
  refreshTable = (closeCarousel) => {
    if (closeCarousel) {
      this.setState({
        expandedIndex: ''
      });
    }
    if (__MANAGE__) {
      this.props.fetchOpenLeadDataArray().then(() => {
        this.props.applyFilter();
      }, errorResponse => debug(errorResponse));
      this.props.fetchManageCampaignData().then(() => {
        this.props.fetchData().then(() => {
          this.props.applyFilter();
        }, errorResponse => debug(errorResponse));
      }, error => debug(error));
    }
  }
  handleSearchChangeForName = (value) => {
    value.stopPropagation();
    this.setState({ expandedIndex: '' });
    if (!__MANAGE__) {
      this.props.updateSelectedRecords('removeAll');
      this.props.searchActivePage();
    }
    const sortedList = util.orderBy(
      this.props.tabSearchList,
      this.state.sortBy,
      this.state.sortDirection,
      SortDirection
    );
    this.props.updateNameSearchParameter(value.target.value, this.props.activeIndex);
    let FilteredData = this.paginatedData = (!__MANAGE__) && this.props.activeIndex === 2 ? // eslint-disable-line
     util.searchField(value.target.value, sortedList, 'cica_customername') : __MANAGE__ ? util.searchField(value.target.value, sortedList, 'quickbarName') : util.searchField(value.target.value, sortedList, 'name');
    if (this.props.searchWritingAgent) {
      FilteredData = util.searchField(this.props.searchWritingAgent, FilteredData, 'cica_writingagent');
    }
    if (__MANAGE__) {
      if (this.props.searchStreetAddress) {
        FilteredData = util.searchField(this.props.searchStreetAddress, FilteredData, 'residentialAddress');
      }
      if (this.props.searchPhone) {
        FilteredData = util.searchFieldPhone(this.props.searchPhone, FilteredData, 'phone', 'residentialPhone');
      }
    } else if (!__MANAGE__) {
      if (this.props.searchStreetAddress) {
        FilteredData = util.searchField(this.props.searchStreetAddress, FilteredData, 'streetAddress');
      }
    }
    this.paginatedData = FilteredData;
    this.props.applySearchName(FilteredData);
  }

  handleSearchChangeForStreet = (value) => {
    value.stopPropagation();
    if (!__MANAGE__) {
      this.props.updateSelectedRecords('removeAll');
      this.props.searchActivePage();
    }
    this.props.updateStreetSearchParameter(value.target.value, this.props.activeIndex);
    const sortedList = util.orderBy(
      this.props.tabSearchList,
      this.state.sortBy,
      this.state.sortDirection,
      SortDirection
    );
    let FilteredData = this.paginatedData = util.searchField(value.target.value, sortedList, 'streetAddress');
    if (this.props.searchValueName) {
      FilteredData = util.searchField(this.props.searchValueName, FilteredData, 'name');
    }
    this.paginatedData = FilteredData;
    this.props.applySearchStreet(FilteredData);
  }

  handleSearchChangeForAddress = (value) => {
    value.stopPropagation();
    if (!__MANAGE__) {
      this.props.updateSelectedRecords('removeAll');
    }
    this.props.updateStreetSearchParameter(value.target.value, this.props.activeIndex);
    const sortedList = util.orderBy(
      this.props.tabSearchList,
      this.state.sortBy,
      this.state.sortDirection,
      SortDirection
    );
    let FilteredData = this.paginatedData = util.searchField(value.target.value, sortedList, 'residentialAddress');
    if (this.props.searchValueName) {
      FilteredData = util.searchField(this.props.searchValueName, FilteredData, 'quickbarName');
    }
    if (this.props.searchPhone) {
      FilteredData = util.searchFieldPhone(this.props.searchPhone, FilteredData, 'phone', 'residentialPhone');
    }
    this.paginatedData = FilteredData;
    this.props.applySearchAddress(FilteredData);
  }

  handleSearchChangeForPhone = (value) => {
    value.stopPropagation();
    if (!__MANAGE__) {
      this.props.updateSelectedRecords('removeAll');
    }
    this.props.updatePhoneParameter(value.target.value, this.props.activeIndex);
    const sortedList = util.orderBy(
      this.props.tabSearchList,
      this.state.sortBy,
      this.state.sortDirection,
      SortDirection
    );
    let FilteredData = this.paginatedData = util.searchFieldPhone(value.target.value, sortedList, 'phone', 'residentialPhone');
    if (this.props.searchValueName) {
      FilteredData = util.searchField(this.props.searchValueName, FilteredData, 'quickbarName');
    }
    if (this.props.searchStreetAddress) {
      FilteredData = util.searchField(this.props.searchStreetAddress, FilteredData, 'residentialAddress');
    }
    this.paginatedData = FilteredData;
    this.props.applySearchPhone(FilteredData);
  }

  handleSearchWritingAgent = (value) => {
    value.stopPropagation();
    if (!__MANAGE__) {
      this.props.updateSelectedRecords('removeAll');
      this.props.searchActivePage();
    }
    this.closeCarousel(this.state.expandedIndex);
    this.props.updateWritingAgentParameter(value.target.value, this.props.activeIndex);
    const sortedList = util.orderBy(
      this.props.tabSearchList,
      this.state.sortBy,
      this.state.sortDirection,
      SortDirection
    );
    let FilteredData = this.paginatedData = util.searchField(value.target.value, sortedList, 'cica_writingagent');
    if (this.props.searchValueName) {
      FilteredData = util.searchField(this.props.searchValueName, FilteredData, 'cica_customername');
    }
    this.paginatedData = FilteredData;
    this.props.applySearchWritingAgent(FilteredData);
  }

  headerClickHandler = ({ dataKey }) => {
    const listToAddOrRemove = [];
    const personIdArray = Object.keys(this.props.priAndSecRecordMapping);
    this.paginatedData.forEach((record) => {
      listToAddOrRemove.push({
        city: record.city,
        county: record.county,
        disposition: record.disposition,
        householdIndicator: record.householdIndicator,
        id: record.id,
        language: record.language,
        lastAssigned: record.lastAssigned,
        assignedTo: record.assignedTo,
        lastSelling: record.lastSelling,
        leadType: record.leadType,
        name: record.name,
        ownerid: record.ownerid,
        state: record.state,
        status: record.status,
        zip: record.zip,
        streetAddress: record.streetAddress,
        lastDispositionDate: record.lastDispositionDate,
        campaign: record.campaign,
        personId: record.personId,
        isSecondary: Boolean(record.isSecondary),
        showHouseKey: record.showHouseKey,
        lastDispositionState: record.lastDispositionState,
        selfAssigned: record.selfAssigned,
        lineOneManager: record.lineOneManager,
        notes: record.notes,
        activeLastSellingAgentName: record.activeLastSellingAgentName
        // isOrphaned: this.record.isOrphaned
      });

      if (personIdArray.indexOf(record.personId) > -1) {
        listToAddOrRemove.push(...this.props.priAndSecRecordMapping[record.personId]);
      }
    });
    if (dataKey === 'checkBox') {
      if (this.getNumberOfSelectedRecords() < this.paginatedData.length) {
        this.props.updateSelectedRecords('addAll', listToAddOrRemove);
      } else {
        this.props.updateSelectedRecords('removeAll', listToAddOrRemove);
      }
    } else if (this.props.updateSelectedRecords) {
      this.props.updateSelectedRecords('removeAll');// Remove all selected if a sort has been done on any
    }
  }
  rowHeight = ({ index }) => {
    if (this.state.expandedIndex === index) {
      if (__MANAGE__) {
        return 457;
      }
      return isIE ? 406 : 410;
    }
    return 45;
  }

  rowRenderer = ({ className, columns, index, onRowClick,
                onRowDoubleClick, onRowMouseOver,
                onRowMouseOut, style, key, rowData }) => {
    const a11yProps = {};
    if (
      onRowClick ||
      onRowDoubleClick ||
      onRowMouseOver ||
      onRowMouseOut
    ) {
      a11yProps['aria-label'] = 'row';
      a11yProps.role = 'row';
      a11yProps.tabIndex = 0;

      if (onRowClick) {
        a11yProps.onClick = () => onRowClick({ index });
      }
      if (onRowDoubleClick) {
        a11yProps.onDoubleClick = () => onRowDoubleClick({ index });
      }
      if (onRowMouseOut) {
        a11yProps.onMouseOut = () => onRowMouseOut({ index });
      }
      if (onRowMouseOver) {
        a11yProps.onMouseOver = () => onRowMouseOver({ index });
      }
    }
    if (!__MANAGE__ && (this.props.activeIndex === 2 || this.props.activeIndex === 0 || this.props.activeIndex === 1) // eslint-disable-line
      && index === this.state.expandedIndex) {
      this.props.callCloseCarousel(false);
      return (
        <div
          {...a11yProps}
          key={key}
          style={style}
        >
          <div
            className={className}
            ref={ref => (this.refToTable = ref)}
            style={{
              height: '3em',
              background: '#55bdfc'
            }}
          >
            {columns}
          </div>
          {this.props.priAndSecRecordMapping[rowData.personId] &&
            <TabbedViewAssign
              closeCarousel={this.closeCarousel}
              tabIndexLeadsCheck={this.props.activeIndex}
              clickedIndex={index}
              listData={rowData}
              secondaryLeads={this.props.priAndSecRecordMapping[rowData.personId]}
              refreshTable={this.refreshTable}
              manageCampaignData={this.props.manageCampaignData}
              strings={this.props.strings}
              ownerId={this.props.ownerId}
              currentLanguage={this.props.currentLanguage}
              updateProgressBarValue={this.props.updateProgressBarValue}
            />
          }
          {!this.props.priAndSecRecordMapping[rowData.personId] &&
            <div>
              <InspCarousel
                closeCarousel={this.closeCarousel}
                tabIndexLeadsCheck={this.props.activeIndex}
                clickedIndex={index}
                listData={rowData}
                strings={this.props.strings}
                updateProgressBarValue={this.props.updateProgressBarValue}
                currentLanguage={this.props.currentLanguage}
                ownerId={this.props.ownerId}
              />
              <div className={(this.props.activeIndex !== 2) ? // eslint-disable-line
                styles.footerPlaceholderLeads : styles.footerPlaceholder}
              />
            </div>
          }
        </div>
      );
    }

    if (__MANAGE__ && index === this.state.expandedIndex) {
      return (
        <div
          {...a11yProps}
          key={key}
          style={style}
        >
          <div
            className={className}
            style={{
              height: '3em',
              background: '#55bdfc'
            }}
          >
            {columns}
          </div>
          {this.props.priAndSecRecordMapping[rowData.personId] &&
            <TabbedView
              closeCarousel={this.closeCarousel}
              clickedIndex={index}
              listData={rowData}
              secondaryLeads={this.props.priAndSecRecordMapping[rowData.personId]}
              refreshTable={this.refreshTable}
              manageCampaignData={this.props.manageCampaignData}
              strings={this.props.strings}
            />
          }
          {!this.props.priAndSecRecordMapping[rowData.personId] &&
            <Carousel
              closeCarousel={this.closeCarousel}
              clickedIndex={index}
              listData={rowData}
              refreshTable={this.refreshTable}
              strings={this.props.strings}
            />
          }
        </div>
      );
    }
    return (
      <div
        {...a11yProps}
        key={key}
        className={className}
        style={style}
      >
        {columns}

      </div>
    );
  }
  checkedLeads = (selectedLeadID) => {
    const personIdArray = Object.keys(this.props.priAndSecRecordMapping);
    this.paginatedData.forEach((element) => {
      if (element.id === selectedLeadID) { // eslint-disable-line
        const checkId = obj => obj.id === element.id;
        if (this.props.selectedRecords.findIndex(checkId) === -1) {
          if (personIdArray.indexOf(element.personId) > -1) {
            this.props.updateSelectedRecords(
              'addAll',
              this.props.priAndSecRecordMapping[element.personId]
            );
          }
          this.props.updateSelectedRecords('add', {
            city: element.city,
            county: element.county,
            disposition: element.disposition,
            householdIndicator: element.householdIndicator,
            id: element.id,
            language: element.language,
            lastAssigned: element.lastAssigned,
            assignedTo: element.assignedTo,
            lastSelling: element.lastSelling,
            leadType: element.leadType,
            name: element.name,
            ownerid: element.ownerid,
            state: element.state,
            status: element.status,
            zip: element.zip,
            lastDispositionDate: element.lastDispositionDate,
            campaign: element.campaign,
            personId: element.personId,
            isSecondary: Boolean(element.isSecondary),
            showHouseKey: element.showHouseKey,
            streetAddress: element.streetAddress,
            lastDispositionState: element.lastDispositionState,
            selfAssigned: element.selfAssigned,
            assignedDate: element.assignedDate,
            lineOneManager: element.lineOneManager,
            notes: element.notes,
            activeLastSellingAgentName: element.activeLastSellingAgentName,
            isOrphaned: element.isOrphaned,
            description: element.description
          });
        } else if (this.props.selectedRecords.findIndex(checkId) > -1) {
          if (personIdArray.indexOf(element.personId) > -1) {
            this.props.updateSelectedRecords(
              'removeAll',
              this.props.priAndSecRecordMapping[element.personId]
            );
          }
          this.props.updateSelectedRecords('remove', {
            city: element.city,
            county: element.county,
            disposition: element.disposition,
            householdIndicator: element.householdIndicator,
            id: element.id,
            language: element.language,
            lastAssigned: element.lastAssigned,
            assignedTo: element.assignedTo,
            lastSelling: element.lastSelling,
            leadType: element.leadType,
            name: element.name,
            ownerid: element.ownerid,
            state: element.state,
            status: element.status,
            zip: element.zip,
            lastDispositionDate: element.lastDispositionDate,
            campaign: element.campaign,
            personId: element.personId,
            isSecondary: Boolean(element.isSecondary),
            showHouseKey: element.showHouseKey,
            streetAddress: element.streetAddress,
            lastDispositionState: element.lastDispositionState,
            selfAssigned: element.selfAssigned,
            lineOneManager: element.lineOneManager,
            notes: element.notes,
            activeLastSellingAgentName: element.activeLastSellingAgentName,
            isOrphaned: element.isOrphaned,
            description: element.description
          });
        }
      }
    });
  }
  renderedRows = ({ startIndex, stopIndex }) => {
    this.setState({ startIndex, stopIndex });
  }
  renderCells = ({ cellData, dataKey, rowData }) => {
    const personIdArray = Object.keys(this.props.priAndSecRecordMapping);
    const strings = this.props.strings;
    if (dataKey === 'checkBox') {
      const id = rowData.id;
      this.setState({ checkBoxValidation: this.state[id] });
      // Return the index of the first element in the array that has id equal to selected record.
      const checkId = obj => obj.id === id;
      return (
        /* eslint-disable */
        <div>
          <div>
            <input
              id ={id}
              theme={styles}
              type="checkbox"
              checked={Boolean(id && this.props.selectedRecords.findIndex(checkId) > -1)}
              onChange={ (evt) => {
                this.checkedLeads(id);
                this.setState({
                  [id]: !this.state[id],
                  expandedIndex: false
                });
                evt.stopPropagation();
              }}
              ref={(ref) => {
                this[id] = ref;
              }}
            />
          </div>
        </div>
      );
    } else if (dataKey === 'disposition' && cellData == null) {
      return 'Unworked';
    } else if (__MANAGE__ && dataKey === 'leadType' && cellData) {
      return (
        <span>
          {String(cellData)}
        </span>
      );
    } else if (__MANAGE__ && (dataKey === 'expires' || dataKey === 'Vence') && cellData) {
      if (cellData <= 5 && (rowData.leadType !== 'Warm' && rowData.leadType !== 'Campaign')) {
        /* eslint-disable */
        return (
          <span className={styles.expiresColorRed}>
            {cellData === 1 ? `${cellData} ${strings.day}` : (cellData !== 'NA') ? `${cellData} ${strings.days}` : `${cellData}`}
          </span>
        );
      } if (rowData.leadType === 'Campaign') {
        /* eslint-disable */
        return (
          <span>
            {cellData === 1 ? `${cellData} ${strings.day}` : (cellData !== 'NA') ? `${cellData} ${strings.days}` : `${cellData}`}
          </span>
        );
      }
      return cellData === 1 ? `${cellData} ${strings.day}` : (cellData !== 'NA') ? `${cellData} ${strings.days}` : `${cellData}`; // eslint-disable-line
    } else if (dataKey === 'callType') {
      return (
        <span>
          {String(cellData)}
        </span>
      );
    } else if (dataKey === 'showHouseKey' && cellData && personIdArray.indexOf(rowData.personId) > -1) {
      if (rowData.leadType === 'Campaign') {
        return (
          <img
            src="static/home.png"
            className={styles.homeCampIcon}
            alt="Home"
          />
        );
      }
      return (
        <img
          src="static/home.png"
          className={styles.homeIcon}
          alt="Home"
        />
      );
    } else if ((dataKey === 'showHouseKey' && rowData.leadType === 'Warm') || (dataKey === 'showHouseKey' && (rowData.isappointmentterminated === true || rowData.isappointmentterminated === 'true' || rowData.isappointmentterminated === 1 || rowData.isappointmentterminated === '1'))) {
      /* eslint-disable */
      return (
        <div>
          <img
            id={rowData.name}
            src="static/info_icon.png"
            className={styles.infoIcon}
            alt="Info"
            onClick={(evt) => {
              this.setState({
                 [rowData.name]: !this.state[rowData.name]
              })
              evt.stopPropagation();
            }}
            ref={(ref) => {
              this[rowData.name] = ref;
            }}
          />
          <Popover
            placement="bottom"
            container={this}
            target={this[rowData.name]}
            show={this.state[rowData.name]}
            onHide={() => {
              this.setState({ [rowData.name]: false });
            }}
          >
            <p className={styles.popMessage}>{( (rowData.isappointmentterminated === true || rowData.isappointmentterminated === 'true' || rowData.isappointmentterminated === '1' || rowData.isappointmentterminated === 1) ? `${rowData.appointmentdate}` : `${rowData.description}`)}</p>
          </Popover>
        </div>
      );
      /* eslint-enable */
    } else if (dataKey === 'icon' && personIdArray.indexOf(rowData.personId) > -1) {
      if (rowData.leadType === 'Campaign') {
        return (
          <img
            src="static/home.png"
            className={styles.campIcon}
            alt="Home"
          />
        );
      }
      return (
        <img
          src="static/home.png"
          className={styles.icon}
          alt="Home"
        />
      );
    } else if (dataKey === 'icon' && rowData.leadType === 'Personal') {
      return (
        <input
          type="image"
          src="static/delete.png"
          alt="Delete"
          className={styles.icon}
          onClick={(e) => {
            e.stopPropagation();
            this.props.updateRowData(rowData);
            this.setState({ confirm: true });
          }}
        />
      );
    } else if (cellData == null || (dataKey === 'showHouseKey' && cellData)) {
      return '';
    } else if (dataKey === 'phoneNumber' && this.props.activeIndex === 2) {
      return (
        <span className={styles.wrapContent}>
          {util.formatPhoneNumber(cellData)}
        </span>
      );
    }
    return (
      <span className={(dataKey === 'streetAddress' || dataKey === 'residentialAddress') ? styles.wrapContentAddress : styles.wrapContent}>
        {String(cellData)}
      </span>
    );
  }
  renderHeader = ({ label, dataKey, sortBy, sortDirection }) => {
    const { strings } = this.props;
    if (dataKey === 'checkBox') {
      return (
        <Checkbox
          checked={Boolean(this.paginatedData.length &&
                      (this.getNumberOfSelectedRecords() === this.paginatedData.length))}
          disabled
          theme={styles}
        />
      );
    }
    /* eslint-disable */
    return (
      <div className={(!__MANAGE__ && this.props.activeIndex === 2) ? styles.headerDiv : styles.headerDivInsp}> 
        <div className={styles.headerLabel}>
          <span className={__MANAGE__ ? styles.wrapHeaderManage : styles.wrapHeader}>
            {label}
          </span>
          {(sortBy === dataKey && dataKey !== 'callType') &&
          <SortIndicator sortDirection={sortDirection} />
          }
          {(sortBy === dataKey && dataKey === 'callType' && this.props.activeIndex === 2) &&
          <SortIndicator sortDirection={sortDirection} />
          }
          {sortBy !== dataKey && label &&
          <SortIndicator sortDirection={''} />
          }
          {dataKey === 'callType' && label === '' &&
          <SortIndicator sortDirection={''} />
          }
        </div>
        {(label === 'Name' || label === 'Nombre') &&
          <CustomTextFieldWithCloseIcon
            name="Customer"
            placeholder={__MANAGE__ ? strings.searchNameManage : strings.searchName}
            className={styles.inputField}
            value={this.props.searchValueName}
            changeEvent={this.handleSearchChangeForName}
          />
        }
        {(label === 'Insured\'s Name' || label === 'Nombre del asegurado') &&
          <CustomTextFieldWithCloseIcon
            name="Customer"
            placeholder={strings.searchInsuredName}
            className={styles.inputFieldCustomerAgent}
            value={this.props.searchValueName}
            changeEvent={this.handleSearchChangeForName}
          />
        }
        { !__MANAGE__ && (label === 'Street Address' || label === 'Domicilio') &&
          <CustomTextFieldWithCloseIcon
            name="SearchAddress"
            placeholder={strings.searchAddress}
            className={styles.inputFieldAssign}
            value={this.props.searchStreetAddress}
            changeEvent={this.handleSearchChangeForStreet}
          />
        }
        {__MANAGE__ && label === strings.address &&
          <CustomTextFieldWithCloseIcon
            name="SearchAddress"
            placeholder={__MANAGE__ ? strings.searchAddressManage : strings.searchAddress}
            className={styles.inputField}
            value={this.props.searchStreetAddress}
            changeEvent={this.handleSearchChangeForAddress}
          />
        }
        {(label === 'Writing Agent' || label === 'Agente suscriptor') &&
          <CustomTextFieldWithCloseIcon
            name="Writing"
            id="mySearch"
            placeholder={strings.searchWritingAgent}
            className={styles.inputFieldWritingAgent}
            value={this.props.searchWritingAgent}
            changeEvent={this.handleSearchWritingAgent}
          />
        }
        {(label === 'Phone' || label === 'Teléfono') &&
          <CustomTextFieldWithCloseIcon
            name="Phone"
            placeholder={strings.searchPhone}
            className={styles.inputFieldWritingAgent}
            value={this.props.searchPhone}
            changeEvent={this.handleSearchChangeForPhone}
          />
        }
      </div>
    );
  }
  /* eslint-enable */
  renderFlexColumns = () => (
    this.props.columnData.map((data) => {
      const { label, dataKey, styleName, flexGrow, index } = data;
      return (
        <Column
          key={dataKey}
          label={label}
          dataKey={dataKey}
          width={0}
          className={(styleName === '') ? styles.wrapContent : styles[styleName]}
          flexGrow={flexGrow}
          headerRenderer={this.renderHeader}
          cellRenderer={this.renderCells}
          disableSort={(dataKey === 'checkBox')}
        />
      );
    })
  )

  render() {
    const {
      headerHeight,
      rowHeight,
      headerClassName,
      rowClassName,
      rowClickHandler,
      gridClassName,
      strings
    } = this.props;

    const rowClass = rowClassName || this.rowClassName;
    const handleClick = rowClickHandler || this.clickHandler;
    const setRowHeight = rowHeight || this.rowHeight;
    this.getSortedPaginatedList();
    const rowGetter = ({ index }) => this.paginatedData[index];
    if (this.props.filterExpanded === true) {
      this.setState({ expandedIndex: false });
    }
    if (__TEST__) {
      /*
        Returing the component with out the Autosizer in the test env
        http://stackoverflow.com/questions/37801005/does-react-virtualized-work-with-airbnb-enzyme
      */
      return (
        <div className={styles.flexTable}>
          <Table
            ref={this.setRef}
            height={this.props.height}
            width={this.props.width}
            headerHeight={headerHeight}
            rowHeight={setRowHeight}
            headerClassName={headerClassName}
            rowClassName={rowClass}
            noRowsRenderer={this.noRowsRenderer}
            rowGetter={rowGetter}
            rowCount={this.paginatedData.length}
            onRowClick={handleClick}
            rowRenderer={this.rowRenderer}
            overscanRowCount={__MANAGE__ ? 500 : 10}
            onHeaderClick={this.headerClickHandler}
            sort={({ sortBy, sortDirection }) => {
              this.setState({
                sortBy,
                sortDirection
              });
            }}
            sortBy={this.state.sortBy}
            sortDirection={this.state.sortDirection}
          >
            {this.renderFlexColumns()}
          </Table>
        </div>
      );
    }
    if (__MANAGE__) {
      return (
        <div className={styles.flexTable}>
          <AutoSizer>
            {({ height, width }) =>
              (
                <Table
                  ref={this.setRef}
                  height={height}
                  width={width}
                  headerHeight={headerHeight}
                  rowHeight={setRowHeight}
                  headerClassName={headerClassName}
                  gridClassName={this.props.popupVisible !== '' ? gridClassName : ''}
                  rowClassName={rowClass}
                  noRowsRenderer={this.noRowsRenderer}
                  rowGetter={rowGetter}
                  rowCount={this.paginatedData.length}
                  onRowClick={handleClick}
                  rowRenderer={this.rowRenderer}
                  overscanRowCount={__MANAGE__ ? 500 : 10}
                  onRowsRendered={this.renderedRows}
                  onHeaderClick={this.headerClickHandler}
                  sort={({ sortBy, sortDirection }) => {
                    this.setState({
                      sortBy,
                      sortDirection
                    });
                  }}
                  sortBy={this.state.sortBy}
                  sortDirection={this.state.sortDirection}
                >
                  {this.renderFlexColumns()}
                </Table>
            )
            }
          </AutoSizer>
          <div className={styles.stickyFooter}>
            {strings.showing} &nbsp;{this.paginatedData.length > 0 ?
              this.state.startIndex + 1 : 0} -
            {this.paginatedData.length > 0 ? this.state.stopIndex + 1 : 0} {strings.of}
            &nbsp;{this.paginatedData.length}
          </div>
          <Modal
            isOpen={this.state.confirm}
            className="modalClass"
            overlayClassName="overlayClass"
          >
            <div className={styles.popupcontainer}>
              <div className={styles.popupDiv}>
                <div className={styles.popup}>
                  <div className={styles.popupBodyDiv}>
                    <span className={styles.contentBody}>
                      {strings.deleteString}
                    </span>
                  </div>
                  <div className={styles.popupFooterDiv}>
                    <div className={styles.okBtnDiv}>
                      <button
                        onClick={this.handleToggle}
                        className={styles.cancelBtn}
                      >{strings.cancel}</button>
                      <button
                        onClick={this.okBtnTapped}
                        className={styles.okBtn}
                      >{strings.ok}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      );
    }
    return (
      <div className={styles.flexTable}>
        <AutoSizer>
          {({ height, width }) =>
            (
              <Table
                ref={this.setRef}
                height={height}
                width={width}
                headerHeight={headerHeight}
                rowHeight={setRowHeight}
                headerClassName={headerClassName}
                rowClassName={rowClass}
                noRowsRenderer={this.noRowsRenderer}
                rowGetter={rowGetter}
                rowCount={this.paginatedData.length}
                onRowClick={handleClick}
                rowRenderer={this.rowRenderer}
                overscanRowCount={__MANAGE__ ? 500 : 10}
                onRowsRendered={this.renderedRows}
                onHeaderClick={this.headerClickHandler}
                sort={({ sortBy, sortDirection }) => {
                  this.setState({
                    sortBy,
                    sortDirection
                  });
                }}
                sortBy={this.state.sortBy}
                sortDirection={this.state.sortDirection}
              >
                {this.renderFlexColumns()}
              </Table>
            )
            }
        </AutoSizer>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  popupVisible: __MANAGE__ ? state.manage.popupVisible : '',
  deletePersonalLead: __MANAGE__ ? state.manage.deletePersonalLead : '',
  manageCampaignData: __MANAGE__ ? state.manage.manageCampaignData : state.assign.campaignData,
  shouldCloseCarousel: state.filter.shouldCloseCarousel,
  rowData: __MANAGE__ ? state.manage.rowData : ''
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    Object.assign(
      {},
      manageActionCreators,
      filterActionCreators
    ), dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(VirtualTable);



// WEBPACK FOOTER //
// ./src/containers/VirtualTable/VirtualTable.js